import '../../assets/components/IconButton/iconbutton.css';const t = "_iconButton_zvqhg_1", o = {
  iconButton: t
};
export {
  o as default,
  t as iconButton
};
